export const getHealthyGums = (t) => ({
    header: t("healthyGums.header"),
    description: t("healthyGums.description", { returnObjects: true }),
    specialCase: {
        header: t("healthyGums.specialCase.header"),
        tips: t("healthyGums.specialCase.tips", { returnObjects: true }),
    },
});
